import { ElementType, createElement } from 'react';
import clsx from 'clsx';
import { generateTestId } from './data';

export interface BoxProps<Component extends ElementType> {
  as?: Component;
  dataTestId: string;
  bgColor?: string;
  className?: string;
  children: React.ReactNode;
}

const Box = <Component extends ElementType>(props: BoxProps<Component>) => {
  const { dataTestId, as: Component = 'div', bgColor, className, children, ...rest } = props;

  const testIds = generateTestId(dataTestId);

  return createElement(
    Component,
    {
      'data-testid': testIds.component,
      className: clsx(
        `${bgColor ? bgColor : 'bg-white'} shadow-sm border border-gray-100 rounded-md p-3 md:p-6`,
        className,
      ),
      rest,
    },
    children,
  );
};

export default Box;
